import { Injectable } from "@angular/core";
import { AuthInterceptor } from "@apps/patient-core/src/app/http-interceptors/auth-interceptor";
import { DEVICES_PATH } from "../services/concierge.service";

@Injectable({
  providedIn: "root",
})
export class ConciergeAuthInterceptor extends AuthInterceptor {
  protected shouldGetAuthToken(url: string): boolean {
    if (url.includes(DEVICES_PATH)) {
      return false;
    }

    return super.shouldGetAuthToken(url);
  }
}
